import React, { useEffect, useState, useRef  } from "react";
import BreadCrumbComp from "../../components/breadCrumb";
import { Grid } from "@mui/material";
import SimpleUnitCard from "../../components/cards/simpleUnitCard";
import { icons } from "../../constants";
import LaddaButton from "../../components/buttons/laddaButton";
import SimpleTable from "../../components/tables/simpleTable";
import SimpleSelect from "../../components/selects/simpleSelect";
import { useForm } from "react-hook-form";
import { actualYearSelect } from "../../services/dateService";
import ModalComponent from "../../components/modals";
import ProgressClientBar from "../../components/progressBar/progressClientBar";
import { getCurrentMonth } from "../../utils/dateUtils";
import { moneyTransform } from "../../utils/utilsFunctions";
import ToastNotification from "../../components/toastNotification";
import { callApiAsync, postMassiveUpload, getBudgetByYear} from "../../services/apiService";
import { useSelector } from "react-redux";
import { canUploadClients } from "../../constants/clientRoles";

const urlApi = process.env.REACT_APP_API_URL;

const columns = [
  { field: "client_name", header: "Nombre del Cliente" },
  { field: "nit", header: "Nit" },
  {
    field: "budget",
    header: "Presupuesto",
    columnType: "custom",
    render: (rowData) => <p className="m-0">{moneyTransform(rowData.budget)}</p>
  },
  {
    field: "executed",
    header: "Ejecutado",
    columnType: "custom",
    render: (rowData) => (
      <p className="m-0">{moneyTransform(rowData.executed)}</p>
    )
  },
  {
    field: "compliance",
    header: "Cumplimiento %",
    columnType: "custom",
    render: (rowData) => (
      <p
        className="table-default-column"
        style={{
          fontWeight: "bold",
          color: rowData.complianceColor,
          padding: "4px 8px",
          borderRadius: "6px",
          textAlign: "center"
        }}
      >
        {rowData.compliance}%
      </p>
    ),
    columnWidth: "140px"
  }
];

const calculateComplianceColor = (data = []) => {
  const dataClone = [...data];

  const sorted = [...dataClone].sort((a, b) => b.budget - a.budget);

  const topCount = Math.ceil(dataClone.length * 0.2);
  const topBudgets = sorted.slice(0, topCount).map((item) => item.client_name);

  return dataClone.map((item) => {
    const compliance =
      item.budget > 0
        ? Number(((item.executed / item.budget) * 100).toFixed(2))
        : 0;

    const color = topBudgets.includes(item.client_name) ? "#22C55E" : "#F25555";

    return {
      ...item,
      compliance,
      complianceColor: color
    };
  });
};


const Clients = () => {
  const userData = useSelector((state) => state.userData.userData);
  const canManageUpload = canUploadClients(userData?.roleList);
  const { control, setValue, getValues } = useForm();
  const [showToast, setShowToast] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    severity: "success",
    summary: "",
    detail: ""
  });
  const [totalAnual, setTotalAnual] = useState(0);
  const [totalProcess, setTotalProcess] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [budget, setBudget] = useState([]);
  const tableDataFormated = calculateComplianceColor(budget);
  const [yearTable, setYearTable] = useState(new Date().getFullYear());

  useEffect(() => {
  getBudget(yearTable);
}, [yearTable]);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    setValue("year", currentYear);
    setValue("yearTable", currentYear);
    getBudget(currentYear);
  }, []);

  const getBudget = (year) => {
    callApiAsync(
      () => getBudgetByYear(year),
      (res) => {
      const data = res.data || [];
      setBudget(data);

      const total = data.reduce((sum, item) => sum + (item.budget || 0), 0);
      const totalExecuted = data.reduce((sum, item) => sum + (item.executed || 0), 0);

      setTotalAnual(total);
      setTotalProcess(totalExecuted);
      }
    );
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const validExtensions = ["xlsx", "xls"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!validExtensions.includes(fileExtension)) {
      alert("Solo se permiten archivos Excel (.xlsx o .xls)");
      e.target.value = null;
      return;
    }

    setSelectedFile(file); 
  };

  const filterData = async (yearSelected) => {
    console.log("Filtrando para el año:", yearSelected);
  };

  const [openUploadModal, setOpenUploadModal] = useState(false);

  const handleOpenUploadModal = () => setOpenUploadModal(true);
  const handleCloseUploadModal = () => setOpenUploadModal(false);

  const handleDownload = () => {
    const path = 'files/client/CargaMasivaClientes.xlsx';
    const fileUrl = `${urlApi}/${path}`;
    
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "CargaMasivaClientes.xlsx";
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const fileInputRef = useRef(null);
  const handleMassiveUpload = () => {
    const year = getValues("year"); 

    if (!selectedFile) {
      alert("Selecciona un archivo primero");
      return;
    }

    if (!year) {
      alert("Selecciona un año");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("year", year);

    postMassiveUpload(formData).then((res) => {
      const { totalRows, registerData } = res.data; 
      const currentYear = new Date().getFullYear();
      setOpenUploadModal(false);
      getBudget(currentYear);
      if (registerData === 0) {
        setToastConfig({
          severity: "error",
          summary: "Archivo no válido",
          detail: "El archivo no contiene registros válidos."
        });
      } else if (registerData < totalRows) {
        setToastConfig({
          severity: "warn",
          summary: "Carga parcial",
          detail: `Se cargaron ${registerData} de ${totalRows} registros.`
        });
      } else {
        setToastConfig({
          severity: "success",
          summary: "Carga masiva completada",
          detail: "El archivo se cargó correctamente."
        });
      }
      setShowToast(true);

       setSelectedFile(null);
      const fileInput = document.getElementById("fileInput");
      if (fileInput) fileInput.value = "";
    })
    .catch(() => {
      setToastConfig({
        severity: "error",
        summary: "Error en carga masiva",
        detail: "Ocurrió un problema al subir el archivo."
      });
      setShowToast(true);
    });
};

  const tableDataSorted = [...tableDataFormated].sort(
  (a, b) => b.budget - a.budget
);

  return (
    <div className="App">
      <BreadCrumbComp />

      {/* Agrupar título y botón */}
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        style={{ marginBottom: "20px" }}
      >
        <Grid item>
        <div className="searchTitle">
        <h1>DASHBOARD DE CLIENTES</h1>
      </div>
        </Grid>
        {canManageUpload && (
        <Grid item>
          <LaddaButton
            variant="contained"
            borderRadius={"15px"}
            width={"200px"}
            height={"40px"}
            color={"#141313"}
            margin={0}
            backgroundColor={"#EFCD00"}
            onClick={handleOpenUploadModal}
          >
            <div className="IHContainer align-center">
              <img
                className="btn-icon"
                src={icons.exclamationboard}
                alt="icon"
                style={{ marginRight: "10px" }}
              />
              <p>Carga Masiva</p>
            </div>
          </LaddaButton>
        </Grid>
        )}
      </Grid>

      <ProgressClientBar
        title="Meta de Ventas Anual (%)"
        totalAnnual={totalAnual}
        progressTotal={totalProcess}
      />

      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} sm={4} md={4}>
          <SimpleUnitCard
            unit={`${moneyTransform(totalAnual)}`}
            text={"Total Presupuesto Anual"}
            color={"#6A6AD8"}
            textColor={"#FFFFFF"}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <SimpleUnitCard
            unit={`${moneyTransform(totalProcess)}`}
            text={"Cumplimiento Real Presupuesto Anual"}
            color={"#F4D658"}
            textColor={"#404040"}
          />
        </Grid>
      </Grid>
<div style={{ position: 'relative' }}>
  <SimpleTable
    data={tableDataSorted}
    columns={columns}
    isPaginated={true}
    globalFilterFields={["client_name", "nit", "budget"]}
  />

  <div
    style={{
      position: "absolute",
      top: "10px",      
      right: "420px",  
      zIndex: 2,       
      display: "flex",
      alignItems: "center",
      gap: "10px"
    }}
  >
    <p className="info-label" style={{ margin: 0 }}>Año:</p>
    <div style={{ minWidth: "150px" }}>
    <SimpleSelect
      name="yearTable"
      control={control}
      options={actualYearSelect}
      value={yearTable}
      defaultValue={new Date().getFullYear()}
      onChange={(e) => {
      const selectedYear = e.target.value;
      setYearTable(selectedYear);
      }}
      margin="0"
    />
  </div>
</div>
</div>

      {canManageUpload && (
      <ModalComponent
        open={openUploadModal}
        handleClose={handleCloseUploadModal}
        title=""
        width="600px"
        actions={<></>}
      >
        <div
          style={{
            justifyContent: "space-between",
            display: "flex",
            alignItems: "center"
          }}
        >
          <span className="gm-title mt-20">Carga Masiva</span>
          <LaddaButton
            width={"180px"}
            margin={"0"}
            fontSize={"12px"}
            variant="outlined"
            onClick={handleDownload}
            backgroundColor="#FFFF"
            color={"#6A6AD8"}
            borderColor={"#6A6AD8"}
          >
            <div className="IHContainer align-center">
              <img
                className="btn-icon"
                src={icons.descargar}
                alt="Descargar"
                style={{ marginRight: "10px" }}
              />
              Descargar pantilla
            </div>
          </LaddaButton>
        </div>
        <br />

        <form>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={8} md={8}>
              <SimpleSelect
                name="year"
                control={control}
                options={actualYearSelect}
                onChange={(e) => console.log(e)}
                margin="0"
              />
            </Grid>
            <Grid item xs={12} sm={4} md={4}>
              <LaddaButton
                margin={"0"}
                width={"100%"}
                fontSize={"12px"}
                variant="contained"
                onClick={() => document.getElementById("fileInput").click()}
              >
                
                <div className="IHContainer align-center">
                  <img
                    className="btn-icon"
                    src={icons.upload}
                    alt="Agregar"
                    style={{ marginRight: "10px" }}
                  />
                  <p>Agregar Archivo</p>
                </div>
              </LaddaButton>
              <input
                id="fileInput"
                type="file"
                style={{ display: "none" }}
                accept=".xlsx,.xls"
                onChange={handleFileChange}
              />
            </Grid>
            <Grid
              item
              xs={12}
              container
              spacing={2}
              justifyContent="center"
              style={{ marginTop: "-10px" }}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                container
                justifyContent="center"
                display="flex"
              >
                <LaddaButton
                  width={"180px"}
                  height={"40px"}
                  fontSize={"12px"}
                  variant="outlined"
                  onClick={handleMassiveUpload}
                >
                  <div className="IHContainer align-center">
                    <img
                      className="btn-icon"
                      src={icons.descargar}
                      alt="Descargar"
                      style={{ marginRight: "10px" }}
                    />
                    Subir Carga Masiva
                  </div>
                </LaddaButton>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </ModalComponent>
      )}

      <br />
      <br />
      <ToastNotification
        severity={toastConfig.severity}
        summary={toastConfig.summary}
        detail={toastConfig.detail}
        showToast={showToast}
        setShowToast={setShowToast}
        position="top-right"
      />
    </div>
  );
};
export default Clients;
